export const Role = {
  User: 'ROLE_USER',
  Anonimus: 'ROLE_ANONYMOUS'
};

export type Role = typeof Role[keyof typeof Role];
